<template>
  <div class="menu-modal-container">
    <change-status-header :displayName="fund" />
    <div class="menu-container">
      <div class="search-field-container">
        <mds-search-field
          class="search-field"
          placeholder="Search"
          label="Search"
          v-model="searchText"
        >
        </mds-search-field>
      </div>
      <div class="menu-heading">
        Menu Name
      </div>
      <table class="mds-data-table menu-table">
        <tbody class="mds-data-table__body">
          <tr v-for="menu in menus" :key="menu.id" class="mds-data-table__row">
            <td class="mds-data-table__cell menu-column">
              {{menu.menuName}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

import ChangeStatusHeader from '@/components/atoms/ChangeStatusHeader';
import MdsSearchField from '@mds/search-field';

export default {
  name: 'menu-list',
  components: {
    ChangeStatusHeader,
    MdsSearchField,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      fund: this.data.fund,
      menus: this.data.menus,
      searchText: '',
    };
  },
  watch: {
    searchText(value) {
      const menuList = this.data.menus;
      if (value) {
        const searchTerm = value.toLowerCase();
        this.menus = menuList.filter((item) => {
          return item.menuName.toLowerCase().includes(searchTerm);
        });
      } else {
        this.menus = menuList;
      }
    },
  },
};
</script>
<style lang="scss">
.menu-modal-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .change-status__header {
    flex: initial;
  }

  .menu-container {
    height: calc(100% - 60px);
    padding: $mds-space-4-x $mds-space-8-x;
    position: relative;
    overflow-x: scroll;

    .search-field-container {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 200px;
      margin-right: $mds-space-8-x;
    }
  }
}
.menu-heading {
  font-weight: $mds-font-weight-bold;
}

.mds-data-table__cell {
  padding-bottom: $mds-space-inset-2-x;
  padding-top: $mds-space-inset-2-x;
}
.menu-table {
  margin-top: $mds-space-4-x;
  .mds-data-table__cell.menu-column {
    padding: $mds-space-2-x 0;
    font-size: $mds-font-size-m;
  }
}
</style>
